import * as React from 'react';

var X = function (_a) {
    var _b = _a.idSuffix, idSuffix = _b === void 0 ? '' : _b;
    return (React.createElement("svg", { "aria-labelledby": "x-icon-".concat(idSuffix), height: "40", role: "img", viewBox: "-9 -9 42 42", width: "40", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", { id: "x-icon-".concat(idSuffix) }, "Invitae's X Page"),
        React.createElement("g", null,
            React.createElement("path", { d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z", fill: "#161616" }))));
};

export { X as default };
//# sourceMappingURL=X.esm.js.map
